/**
 * LanguageIcon/index.js
 * desc: language icon
 * note: entity icon via IconButton; defaults its tooltip + accessible name to the
 *       icon label. Renders an accessible button when given an onClick handler.
 */
'use strict';

import IconButton from '../IconButton';
import { translate } from '../../../utilities/localization';


const LanguageIcon = ({ tooltip, ...props }) => (
    <IconButton
        baseClassName="language icon"
        // accessible name follows the tooltip override so the visible tip + aria-label always match
        label={ tooltip || translate('icons.language.tooltip.text') }
        tooltip={ tooltip }
        { ...props }
    >
        <svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M0 10C0 4.48 4.47 0 9.99 0 15.52 0 20 4.48 20 10S15.52 20 9.99 20C4.47 20 0 15.52 0 10zm13.97-4h2.95a8.03 8.03 0 00-4.33-3.56c.6 1.11 1.06 2.31 1.38 3.56zM10 2.04c.83 1.2 1.48 2.53 1.91 3.96H8.09C8.52 4.57 9.17 3.24 10 2.04zM2 10c0 .69.1 1.36.26 2h3.38c-.08-.66-.14-1.32-.14-2 0-.68.06-1.34.14-2H2.26C2.1 8.64 2 9.31 2 10zm1.08 4h2.95c.32 1.25.78 2.45 1.38 3.56A7.987 7.987 0 013.08 14zm0-8h2.95c.32-1.25.78-2.45 1.38-3.56-1.84.63-3.37 1.9-4.33 3.56zM10 17.96c-.83-1.2-1.48-2.53-1.91-3.96h3.82c-.43 1.43-1.08 2.76-1.91 3.96zM7.5 10c0 .68.07 1.34.16 2h4.68c.09-.66.16-1.32.16-2 0-.68-.07-1.35-.16-2H7.66c-.09.65-.16 1.32-.16 2zm5.09 7.56c.6-1.11 1.06-2.31 1.38-3.56h2.95a8.03 8.03 0 01-4.33 3.56zM14.5 10c0 .68-.06 1.34-.14 2h3.38c.16-.64.26-1.31.26-2s-.1-1.36-.26-2h-3.38c.08.66.14 1.32.14 2z" /></svg>
    </IconButton>
);


export default LanguageIcon;
